import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./App.css";
import { ROUTES } from "./data";
import Home from "./components/home/Home";
import AllProjects from "./components/all-projects/AllProjects";
import AllCertifications from "./components/all-certifications/AllCertifications";

function App() {
  return (
    <Router>
      <Routes>
        <Route path={ROUTES.HOME} element={<Home />} />
        <Route
          path={ROUTES.ALL_CERTIFICATIONS}
          element={<AllCertifications />}
        />
        <Route path={ROUTES.ALL_PROJECTS} element={<AllProjects />} />
      </Routes>
    </Router>
  );
}

export default App;
